import { modifiableContextFactory } from 'src/lib/modifiable-context';

export const {
    ModifiableContext: AccountContext,
    ModifiableProvider: AccountProvider,
    useModifiableContext: useAccount,
} = modifiableContextFactory();

export default useAccount;